"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard").default;
var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault").default;
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionPanel = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireWildcard(require("react"));
var _AccordionItem = require("../AccordionItem/AccordionItem.context");
var _AccordionPanel = require("./AccordionPanel.styles");
/**
 * Contains the content that is hidden and revealed by its sibling
 * `Accordion.Header`.
 *
 * @since 8.43.0
 */

var AccordionPanel = /*#__PURE__*/(0, _react.forwardRef)(function (props, forwardedRef) {
  var _useContext = (0, _react.useContext)(_AccordionItem.AccordionItemContext),
    expanded = _useContext.expanded,
    panelId = _useContext.panelId,
    headerId = _useContext.headerId;
  return /*#__PURE__*/_react.default.createElement(_AccordionPanel.StyledAccordionPanel, (0, _extends2.default)({
    ref: forwardedRef,
    "aria-labelledby": headerId,
    id: panelId,
    hidden: !expanded
  }, props));
});
exports.AccordionPanel = AccordionPanel;
AccordionPanel.displayName = 'Accordion.Panel';
AccordionPanel.propTypes = process.env.NODE_ENV !== "production" ? {
  /**
   * The styled-components
   * [polymorphic "as"](https://styled-components.com/docs/api#as-polymorphic-prop) prop.
   */
  // eslint-disable-next-line zillow/react/forbid-prop-types
  as: _propTypes.default.any,
  children: _propTypes.default.node.isRequired,
  /**
   * A [role](https://www.w3.org/TR/wai-aria-1.2/#roles) is required for assistive
   * technologies to announce the panel properly. Panel uses the
   * [region](https://www.w3.org/TR/wai-aria-1.2/#region) role.
   */
  role: _propTypes.default.string
} : {};
AccordionPanel.defaultProps = {
  role: 'region'
};